import React from 'react';
import Layout from '../../components/Layout';
import Careers from './Careers';

const title = 'Careers at BestHand — Build the Future of Local Services';
const description =
  'Join BestHand and help connect people with trusted local pros. No open roles right now — tell us about yourself and we’ll reach out when the right one opens up.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <Careers />
      </Layout>
    ),
  };
}

export default action;
